import {Component} from "react";

import "./assets/toolboxItem.css"
import {Tooltip} from "@mui/material";


class ToolboxItemInList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type : props.type,
            icon: props.icon,
            id: props.id,
            label : props.label
        }
    }

    clickMe = () =>{
        if ( this.props.onClick !== undefined) {
            this.props.onClick(this)
        }
    }

    getType = () =>{
       return (this.state.type)
    }


    render() {
        return (

                <div style={{fontSize:"12px",width: "100%"}}  onClick={()=>{this.clickMe()}} >
                    {this.state.label}
                </div>
        )
    }
}

export default ToolboxItemInList
